import { getThemeColor, Switch, Text } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Option = styled(Switch).attrs({
  labelPosition: 'before',
})`
  display: flex;
  justify-content: space-between;
  position: relative;
`;

export const OptionText = styled(Text).attrs({
  variant: 'p',
})`
  font-size: 14px;
`;

export const SubOptions = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 12px 8px 0px;
  border-top: 1px solid ${getThemeColor('l4')};
`;
